import {
  effectivityPercent,
  targetAchievementPercent,
  absenceRatePercent,
  formatPercent,
} from './workTimeReportUtils';
import { numberToString } from '../../../components/special/numberConverter';

function csvEscape(value) {
  if (value === null || value === undefined) return '';
  const s = String(value);
  if (s.includes(';') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

// Hours rendered using the user-configured decimal separator (from cookie,
// populated by api.js from the server config). No thousands separator so the
// value stays parseable as a single number by spreadsheet tools.
function hoursLocalized(seconds, decimals = 1) {
  const value = seconds ? seconds / 3600 : 0;
  return numberToString(value, decimals, '');
}

export function exportWorkTimeReportCsv({ entries, startDate, endDate }) {
  const header = [
    'Name',
    'Kunden h',
    'Intern h',
    'Urlaub bezahlt h',
    'Urlaub unbezahlt h',
    'Krank h',
    'Gesamt h',
    'Effektivität %',
    'Soll h',
    'Soll-Erfüllung %',
    'Ausfallquote %',
    'Buchungstage',
    'Abrechenbar h',
  ];
  const rows = entries.map((e) => [
    `${e.user.firstName || ''} ${e.user.lastName || ''}`.trim(),
    hoursLocalized(e.customerWorkedTimeInSeconds),
    hoursLocalized(e.internalWorkedTimeInSeconds),
    hoursLocalized(e.payedVacationInSeconds),
    hoursLocalized(e.unpayedVacationInSeconds),
    hoursLocalized(e.sickTimeInSeconds),
    hoursLocalized(e.workedTimeInSeconds),
    formatPercent(effectivityPercent(e)),
    hoursLocalized(e.targetWorkedTimeInSeconds),
    formatPercent(targetAchievementPercent(e)),
    formatPercent(absenceRatePercent(e)),
    e.bookingDaysCount ?? 0,
    hoursLocalized(e.billableWorkedTimeInSeconds),
  ]);

  const csv = [header, ...rows]
    .map((row) => row.map(csvEscape).join(';'))
    .join('\n');

  // BOM for Excel UTF-8 compatibility
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `mitarbeiter-bericht_${startDate}_${endDate}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
